<template>
  <div v-if="$can('read', 'cameras_media')" style="width: 100%">
    <template v-if="camera.is_push_camera == 1">
      <el-card
        body-style="padding: 10px"
        shadow="never"
      >
        <template slot="header">
          <span>Адреса публикации</span>
          <show-parameter-button
            style="margin-left: 20px;"
            parameter="showCameraPublishUrls"
            :is-parameter-showed="showCameraPublishUrls"
            :on-click="onShowCameraPublishUrls"
          />
        </template>
        <el-table
          v-if="showCameraPublishUrls"
          :data="camera.publish_urls"
          fit
        >
          <el-table-column
            label="Название потока"
            width="200"
            prop="stream_name"
          >
            <template slot-scope="scope">
              <b>{{ scope.row.stream_name }}</b>
            </template>
          </el-table-column>
          <el-table-column
            label="Адрес потока"
            prop="publish_url"
          >
            <template slot-scope="scope">
              {{ scope.row.publish_url }}
            </template>
          </el-table-column>
          <el-table-column width="40">
            <template slot-scope="scope">
              <el-tooltip content="Скопировать">
                <span
                  style="cursor: pointer"
                  @click="copyData(scope.row.publish_url)"
                >
                  <fa :icon="['far', 'copy']" />
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <br />
    </template>
    <template v-if="camera.is_push_camera == 0">
      <el-card body-style="padding: 10px" shadow="never">
        <template slot="header">
          <span>Адреса забора потоков</span>
          <show-parameter-button
            style="margin-left: 20px;"
            parameter="showCameraStreamsUrls"
            :is-parameter-showed="showCameraStreamsUrls"
            :on-click="onShowCameraStreamsUrls"
          />
        </template>
        <el-table :data="fieldsStreamsUrls" :show-header="false" fit>
          <el-table-column width="160" prop="title">
            <template slot-scope="scope">
              <b>{{ scope.row.title }}</b>
            </template>
          </el-table-column>
          <el-table-column prop="key">
            <template slot-scope="scope">
              <template v-if="showCameraStreamsUrls">
                {{ cameraStreamsUrls[scope.row.key] }}
              </template>
              <template v-else>
                скрыто
              </template>
            </template>
          </el-table-column>
          <el-table-column width="40">
            <template slot-scope="scope">
              <el-tooltip v-if="showCameraStreamsUrls && cameraStreamsUrls[scope.row.key]" content="Скопировать">
                <span
                  style="cursor: pointer"
                  @click="copyData(cameraStreamsUrls[scope.row.key].trim())"
                >
                  <fa :icon="['far', 'copy']" />
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <br />
    </template>
    <el-card body-style="padding: 10px" shadow="never">
      <template slot="header">
        <span>Адреса раздачи</span>
        <show-parameter-button
          style="margin-left: 20px;"
          parameter="stream_data"
          :is-parameter-showed="showCameraStreamData"
          :on-click="onShowCameraStreamData"
        />
      </template>
      <el-switch
        v-if="showCameraStreamData"
        v-model="camera.is_return_sldp_links"
        :disabled="!$can('update', 'cameras') || camera.is_deleted === 1"
        active-text="Отключить SLDP-ссылки"
        :active-value="0"
        :inactive-value="1"
        style="padding: 10px 10px"
      />
      <el-switch
        v-if="showCameraStreamData"
        v-model="camera.disable_sub_stream"
        :disabled="!$can('update', 'cameras') || camera.is_deleted === 1"
        active-text="Отключить sub-потоки"
        :active-value="1"
        :inactive-value="0"
        style="padding: 10px 10px"
      />
      <el-table :data="fields" :show-header="false" fit>
        <el-table-column width="160" prop="title">
          <template slot-scope="scope">
            <b>{{ scope.row.title }}</b>
          </template>
        </el-table-column>
        <el-table-column prop="key">
          <template slot-scope="scope">
            <template v-if="scope.row.hideable && !showCameraPreviewPath">
              <show-parameter-button
                :parameter="scope.row.key"
                :is-parameter-showed="showCameraPreviewPath"
                :on-click="onShowCameraPreviewPath"
              />
            </template>
            <template v-else-if="camera[scope.row.key]">
              <el-tooltip v-if="scope.row.isStream" content="Открыть">
                <span style="cursor: pointer" @click="onOpenStream(scope.row.key)">
                  <i style="text-decoration: underline">
                    {{ camera[scope.row.key] }}
                  </i>
                  <fa style="margin-left: 5px" :icon="['far', 'eye']" />
                </span>
              </el-tooltip>
              <span v-else>
                {{ camera[scope.row.key] }}
              </span>
            </template>

            <template v-else-if="scope.row.key === 'desktop_player'">
              <el-tooltip v-if="scope.row.isStream" content="Открыть плеер">
                <span style="cursor: pointer" @click="onOpenStream(scope.row.key)">
                  <i style="text-decoration: underline">{{ scope.row.fieldText }}</i>
                  <fa style="margin-left: 5px" :icon="['far', 'eye']" />
                </span>
              </el-tooltip>
            </template>

            <template v-else>
              -
            </template>
          </template>
        </el-table-column>
        <el-table-column width="40" prop="key">
          <template slot-scope="scope">
            <el-tooltip v-if="camera[scope.row.key]" content="Скопировать">
              <span
                style="cursor: pointer"
                @click="
                  copyData(
                    !isEmpty(camera[scope.row.signature])
                      ? camera[scope.row.key] + '?' + camera[scope.row.signature]
                      : camera[scope.row.key]
                  )
                "
              >
                <fa :icon="['far', 'copy']" />
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <br />
    <el-card
      header="Информация о потоках"
      body-style="padding: 10px"
      shadow="never"
    >
      <el-table :data="fieldsStreamsInfo" :show-header="false" fit>
        <el-table-column width="160" prop="title">
          <template slot-scope="scope">
            <b>{{ scope.row.title }}</b>
          </template>
        </el-table-column>
        <el-table-column prop="key">
          <template slot-scope="scope">
            <template v-if="scope.row.key">
              <span>{{ camera[scope.row.key] || "Нет данных" }}</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      v-if="openedStream"
      :title="openedStream.title"
      :visible.sync="showDialog"
      :width="openedStream.dialogWidth"
      @closed="onCloseStreamDialog"
    >
      <component :is="openedStream.component" :url="openedStream.stream" :signature="openedStream.signature" />
      <timeline
        v-if="openedStream.key === 'hls_archive'"
        :id="camera.id_camera"
        :timezone="camera.timezone"
        style="margin-top: 15px"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { faCopy, faEye } from "@fortawesome/free-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import copyBuffer from "@/core/mixins/copyBuffer";
import { ApiService } from "@/api";
import ShowParameterButton from "@/core/components/features/ShowParameterButton.vue";

library.add(faCopy, faEye);

const DEFAULT_FIELDS = [
  {
    key: "preview_path",
    title: "Превью камеры",
    isStream: true,
    dialogWidth: "30%",
    hideable: true,
  },
  {
    key: "desktop_player",
    title: "Тестовый плеер",
    isStream: true,
    fieldText: "Открыть плеер",
    dialogWidth: "70%",
  },
];

export default {
  name: "CameraMedia",
  components: {
    ShowParameterButton,
    PlayerLive: () => import(/* webpackChunkName: "livePlayer" */ "@/components/Player/components/PlayerLive"),
    PlayerArchive: () => import(/* webpackChunkName: "archivePlayer" */ "@/components/Player/components/PlayerArchive"),
    PlayerWebRtc: () => import(/* webpackChunkName: "webRtcPlayer" */ "@/components/Player/components/PlayerWebRtc"),
    PlayerPreview: () => import("@/components/Player/components/PlayerPreview"),
    PlayerDesktop: () => import("@/components/Player/components/PlayerDesktop"),
    Timeline: () => import("@/components/Timeline"),
    fa,
  },
  mixins: [copyBuffer],
  props: {
    fetch: {
      type: Boolean,
      default: false,
    },
    removeParameterFromHiddenFields: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      showDialog: false,
      openedStream: null,
      showCameraStreamsUrls: false,
      showCameraPublishUrls: false,
      showCameraStreamData: false,
      showCameraPreviewPath: false,
      streamDataFields: [
        {
          key: "rtsp_main",
          title: "RTSP (MAIN) поток",
          isStream: false,
          dialogWidth: "50%",
          signature: "signature",
        },
        {
          key: "rtsp_sub",
          title: "RTSP (SUB) поток",
          isStream: false,
          dialogWidth: "50%",
          signature: "sub_signature",
        },
        {
          key: "sldp_main",
          title: "SLDP (MAIN) поток",
          isStream: true,
          dialogWidth: "50%",
          signature: "signature",
        },
        {
          key: "sldp_sub",
          title: "SLDP (SUB) поток",
          isStream: true,
          dialogWidth: "50%",
          signature: "sub_signature",
        },
        {
          key: "webrtc_main",
          title: "Web_RTC (MAIN) поток",
          isStream: true,
          dialogWidth: "50%",
          signature: "signature",
        },
        {
          key: "webrtc_sub",
          title: "Web_RTC (SUB) поток",
          isStream: true,
          dialogWidth: "50%",
          signature: "sub_signature",
        },
        {
          key: "hls_archive",
          title: "HLS архив",
          isStream: true,
          dialogWidth: "50%",
          signature: "signature",
        },
      ],
      fields: [ ...DEFAULT_FIELDS, ],
      fieldsStreamsInfo: [
        {
          key: null,
          title: "Сервер (MAIN)",
        },
        {
          key: "nimble_main_bandwidth_caption",
          title: "Битрейт",
        },
        {
          key: "nimble_main_resolution",
          title: "Разрешение",
        },
        {
          key: "nimble_main_video_codec",
          title: "Видео-кодек",
        },
        {
          key: "nimble_main_audio_codec",
          title: "Аудио-кодек",
        },
        {
          key: null,
          title: "Сервер (SUB)",
        },
        {
          key: "nimble_sub_bandwidth_caption",
          title: "Битрейт",
        },
        {
          key: "nimble_sub_resolution",
          title: "Разрешение",
        },
        {
          key: "nimble_sub_video_codec",
          title: "Видео-кодек",
        },
        {
          key: "nimble_sub_audio_codec",
          title: "Аудио-кодек",
        },
      ],
      fieldsStreamsUrls: [
        {
          key: "camera_stream_main",
          title: "MAIN поток",
        },
        {
          key: "camera_stream_sub",
          title: "SUB поток",
        },
      ],
    };
  },
  computed: {
    ...mapState("cameras", {
      camera: (state) => state.camera,
      cameraStreamsUrls: (state) => state.cameraStreamsUrls,
    }),
    ...mapState("auth", {
      token: (state) => state.token,
    }),
  },
  methods: {
    ...mapActions("cameras", {
      getCameraStreamsUrls: "GET_CAMERA_STREAMS_URLS",
      getCameraPublishUrls: "GET_CAMERA_PUBLISH_URLS",
      getCameraStreamsData: "GET_CAMERA_STREAMS_DATA",
      getCameraPreviewPath: "GET_CAMERA_PREVIEW_PATH",
    }),
    onOpenStream(streamKey) {
      const selectedField = this.fields.find((field) => field.key === streamKey);
      this.openedStream = {
        ...selectedField,
        signature: selectedField.key === "desktop_player" ? "" : selectedField.key.includes("_sub") ? this.camera.sub_signature : this.camera.signature,
        stream: selectedField.key === "desktop_player"
          ? this.getPlayerUrl()
          : this.camera[selectedField.key],
        component: selectedField.key === "preview_path"
          ? "player-preview"
          : selectedField.key === "desktop_player"
            ? "player-desktop"
            : selectedField.key === "hls_archive"
              ? "player-archive"
              : selectedField.key.startsWith("webrtc_")
                ? "player-web-rtc"
                : "player-live",
      };

      this.showDialog = true;
    },
    onCloseStreamDialog() {
      this.openedStream = null;
    },
    onShowCameraStreamsUrls() {
      if(!this.showCameraStreamsUrls) {
        this.getCameraStreamsUrls(this.camera.id_camera)
          .then(() => {
            this.showCameraStreamsUrls = true;
          })
      }
    },
    onShowCameraPublishUrls() {
      if(!this.showCameraPublishUrls) {
        this.getCameraPublishUrls(this.camera.id_camera)
          .then(() => {
            this.showCameraPublishUrls = true;
          })
      }
    },
    onShowCameraStreamData() {
      if(!this.showCameraStreamData) {
        this.getCameraStreamsData(this.camera.id_camera)
          .then(() => {
            this.fields = [
              ...this.streamDataFields,
              ...DEFAULT_FIELDS,
            ]
            this.showCameraStreamData = true;
            this.removeParameterFromHiddenFields('stream_data');
          })
      }
    },
    onShowCameraPreviewPath() {
      if(!this.showCameraPreviewPath) {
        this.getCameraPreviewPath(this.camera.id_camera)
          .then(() => {
            this.showCameraPreviewPath = true;
          })
      }
    },
    isEmpty(value) {
      return value == null || (typeof value === "string" && value.trim().length === 0);
    },
    resetMediaFields() {
      this.fields = [...DEFAULT_FIELDS];
      this.showCameraStreamsUrls = false;
      this.showCameraPublishUrls = false;
      this.showCameraStreamData = false;
      this.showCameraPreviewPath = false;
    },
    getPlayerUrl() {
      const baseUrl = `${process.env.VUE_APP_OPERATOR_PLAYER_URL}`

      const searchParams = new URLSearchParams({
        id: this.camera.id_camera,
        token: this.token,
        operator: ApiService.operator.operatorId(), /* ссылка будет заменена на другую, когда будет развернутая версия desktop-player для b2o. Пока оставил такую ссылку для наглядности */
      });
      const nodeEnv = process.env.NODE_ENV;
      if (['development', 'staging'].includes(nodeEnv)) {
        searchParams.set('env', process.env.VUE_APP_OPERATOR_PLAYER_CUSTOM_ENV || nodeEnv)
      }

      return `${baseUrl}/?${searchParams.toString()}`
    },
  },
};
</script>

<style>
.camera_info__title {
  font-weight: bold;
  text-transform: uppercase;
  color: #000;
}
.camera_info__label {
  font-size: 14px;
  color: #5a5e66;
  line-height: 0px;
  padding: 0 6px 0 0;
  font-weight: bold;
}
</style>
